export function applicationErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => {
      if (typeof item === "string") return item.trim();
      return typeof item?.msg === "string" ? item.msg.trim() : "";
    }).filter(Boolean);
    if (messages.length) return [...new Set(messages)].join(" ");
  }
  return fallback;
}
